/**
 * Stepper Molecule
 *
 * A progress bar component showing step completion.
 * Simple visual indicator for multi-step processes.
 */

interface StepperProps {
  currentStep: number;
  totalSteps: number;
}

export const Stepper = ({ currentStep, totalSteps }: StepperProps) => {
  return (
    <div className='absolute inset-x-0 -bottom-[9px] flex h-2 w-full items-center bg-slate-200'>
      <div
        className='bg-primary h-full transition-all duration-30'
        style={{ width: `${(currentStep / totalSteps) * 100}%` }}
      />
    </div>
  );
};

export default Stepper;
